import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-dn-button',
  templateUrl: './dn-button.component.html',
  styleUrls: ['./dn-button.component.scss']
})
export class DnButtonComponent implements OnInit {

  @Input()
  caption: string = "";

  @Input()
  fullWidth = false;

  @Input()
  fullHeight = false;

  @Input()
  disabled = false;

  @Input()
  size: 'large' | 'medium' | 'small' = 'large';

  @Input()
  color: 'primary' | 'accent' | 'default' | 'warn' | 'transparent' = 'primary'

  @Output()
  onClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  click(event) {
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }
}
